module.exports = __webpack_public_path__ + "static/media/parth.e803973e.jpg";